import { AUTH_REGION } from './constants';

/** V2 map styles we expose today. Monochrome/Satellite can be added later. */
export const MAP_STYLE_NAMES = ['Standard', 'Hybrid'] as const;
export type MapStyleName = (typeof MAP_STYLE_NAMES)[number];

/**
 * Styles that support the real-time traffic layer. Per AWS, traffic renders on
 * Standard, Monochrome, and Hybrid — only pure Satellite is excluded. Both
 * styles we expose support it, so the guard is currently a no-op, but it keeps
 * the contract correct if Satellite is added later.
 */
const TRAFFIC_SUPPORTED_STYLES: MapStyleName[] = ['Standard', 'Hybrid'];

interface BuildMapStyleUrlArgs {
  style: MapStyleName;
  traffic?: boolean;
}

/**
 * Builds an Amazon Location Service Maps V2 style-descriptor URL for MapLibre.
 * No `?key=` is added: requests are SigV4-signed via the map transformRequest.
 */
export function buildMapStyleUrl({
  style,
  traffic,
}: BuildMapStyleUrlArgs): string {
  const base = `https://maps.geo.${AUTH_REGION}.amazonaws.com/v2/styles/${style}/descriptor`;
  const trafficOn =
    Boolean(traffic) && TRAFFIC_SUPPORTED_STYLES.includes(style);
  return trafficOn ? `${base}?traffic=Congestion` : base;
}
